import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { LevelChangerThing } from "./levelChangerThing";

export class LevelDown extends LevelChangerThing {
	static key = "LevelDown";
	constructor(xy: XY, destinationLevel: number) {
		super(xy, destinationLevel);
	}

	static deserialize(data: any): LevelDown {
		const l = new LevelDown(deserializeXY(data.xy), data.destinationLevel);
		l.visualId = data.visualId;
		return l;
	}
}
